import { pick } from '@ota-frontend/core/utils'

export default class Areas {
  constructor(areas = []) {
    this.areas = areas
  }

  map(f) {
    return new Areas(this.areas.map(f))
  }

  filter(f) {
    return new Areas(this.areas.filter(f))
  }

  // regions

  findRegionById(id) {  // id: int
    if (!id) return undefined

    const region = this.areas.find(a => a.region_id === id)
    return region
        ? pick(['region_id', 'region_name_ja', 'region_name_en'])(region)
        : undefined
  }

  findRegionsByIds(ids) {  // ids: array of int
    return ids.map(this.findRegionById.bind(this)).filter(Boolean)
  }

  existsRegion(id) {
    return this.areas.some(a => a.region_id === id)
  }

  resolveRegionName(regionId) {  // regionId: int
    const region = this.findRegionById(regionId)
    return region ? region.region_name_ja : undefined
  }

  resolveRegionNameEn(regionId) {  // regionId: int
    const region = this.findRegionById(regionId)
    return region ? region.region_name_en : undefined
  }

  // countries

  findCountryById(id) {  // id: int
    if (!id) return undefined

    const country = this.areas.find(a => a.country_id === id)
    return country
        ? pick(['region_id', 'region_name_ja', 'region_name_en',
                'country_id', 'country_name_ja', 'country_name_en'])(country)
        : undefined
  }

  findCountriesByIds(ids) {  // ids: array of int
    return ids.map(this.findCountryById.bind(this)).filter(Boolean)
  }

  filterByRegionId(id) {
    return new Areas(this.areas.filter(a => a.region_id === id))
  }

  existsCountry(id) {
    return this.areas.some(a => a.country_id === id)
  }

  resolveCountryName(countryId) {  // countryId: int
    const country = this.findCountryById(countryId)
    return country ? country.country_name_ja : undefined
  }

  resolveCountryNameEn(countryId) {  // countryId: int
    const country = this.findCountryById(countryId)
    return country ? country.country_name_en : undefined
  }

  get onlyCountriesOrMoreDetailed() {
    return new Areas(this.areas.filter(a => !!a.country_id))
  }

  // cities

  findCityById(id) {  // id: int
    return id && this.areas.find(a => a.city_id === id)
  }

  findCitiesByIds(ids) {  // ids: array of int
    return ids.map(this.findCityById.bind(this)).filter(Boolean)
  }

  filterByCountryId(id) {
    return new Areas(this.areas.filter(a => a.country_id === id))
  }

  existsCity(id) {
    return this.areas.some(a => a.city_id === id)
  }

  resolveCityName(cityId) {  // cityId: int
    const city = this.findCityById(cityId)
    return city ? city.city_name_ja : undefined
  }

  resolveCityNameEn(cityId) {  // cityId: int
    const city = this.findCityById(cityId)
    return city ? city.city_name_en : undefined
  }

  get onlyCitiesOrMoreDetailed() {
    return new Areas(this.areas.filter(a => !!a.city_id))
  }

  // districts

  findDistrictById(id) {  // id: int
    return id && this.areas.find(a => a.district_id === id)
  }

  findDistrictsByIds(ids) {  // ids: array of int
    return ids.map(this.findDistrictById.bind(this)).filter(Boolean)
  }

  filterByCityId(id) {
    return new Areas(this.areas.filter(a => a.city_id === id))
  }

  existsDistrict(id) {
    return this.areas.some(a => a.district_id === id)
  }

  resolveDistrictName(districtId) {  // districtId: int
    const district = this.findDistrictById(districtId)
    return district ? district.district_ja : undefined
  }

  resolveDistrictNameEn(districtId) {  // districtId: int
    const district = this.findDistrictById(districtId)
    return district ? district.district_en : undefined
  }

  get onlyDistrictsOrMoreDetailed() {
    return new Areas(this.areas.filter(a => !!a.district_id))
  }
}
